import React, { useEffect, useCallback, Fragment } from "react";
import { useParams } from "react-router-dom";
import AllMainTreatmentTr from "./AllMainTreatmentTr";
import baseUrl from "../../../../../../../../api/baseUrl";
import AllSubTreatmentTr from "./AllSubTreatmentTr";

const Treatments: React.FC<any> = ({
  allTeatment,
  setallTeatment,
  handleAddSubTreatmentModal,
}) => {
  const { ID } = useParams<{ ID: string }>();

  const getData = useCallback(
    (id: string) => {
      baseUrl
        .get("treatment/find-treatment", {
          headers: { treatmentid: id },
        })
        .then((response) => {
          setallTeatment(response.data.data.treatment);
        })
        .catch((error) => {
          console.error("Error fetching treatment data:", error);
        });
    },
    [setallTeatment]
  );

  useEffect(() => {
    if (ID) {
      getData(ID);
    }
  }, [ID, getData]);

  const removediagnose = useCallback(
    (e: any) => {
      if (e._id) {
        setallTeatment((prevTreatments: any) =>
          prevTreatments.filter((treatment: any) => treatment._id !== e._id)
        );

        baseUrl
          .post(
            "treatment/remove-treatments",
            {},
            {
              headers: {
                treatmentid: ID,
                treatmentsid: e._id,
              },
            }
          )
          .then(() => {
            console.log("Treatment removed successfully.");
          })
          .catch((error) => {
            console.error("Error removing treatment:", error);
          });
      } else {
        setallTeatment((prevTreatments: any) =>
          prevTreatments.filter((treatment: any) => treatment.tid !== e.tid)
        );
      }
    },
    [ID, setallTeatment]
  );

  const refresh = useCallback(() => {
    if (ID) {
      getData(ID);
    }
  }, [ID, getData]);

  return (
    <table className="treatments">
      <thead>
        <tr>
          <th>date</th>
          <th>Treatment</th>
          <th>Tooth No</th>
          <th>Surface</th>
          <th>Quantity</th>
          <th>Price</th>
          <th>Status</th>
          <th>Dentist</th>
          <th>Note</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {allTeatment?.map((item: any, index: number) => (
          <Fragment key={index}>
            <AllMainTreatmentTr
              item={item}
              handleAddSubTreatmentModal={handleAddSubTreatmentModal}
              onClick={() => removediagnose(item)}
              refresh={refresh}
            />
            {item?.subTreatment?.length > 0 && (
              <tr key={index}>
                <td colSpan={10}>
                  <div className="sub_table">
                    <div className="sub_table_container">
                      <div className="header">
                        <h4>Case Treatment</h4>
                      </div>
                      <div className="table_container">
                        <table>
                          <thead>
                            <tr>
                              <th>date</th>
                              <th>treatment</th>
                              <th>tooth No</th>
                              <th>Surface</th>
                              <th>QTY</th>
                              <th>price</th>
                              <th>Dentist</th>
                              <th>Note</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item?.subTreatment?.map(
                              (items: any, i: number) => (
                                <AllSubTreatmentTr
                                  allTeatment={allTeatment}
                                  setallTeatment={setallTeatment}
                                  key={i}
                                  items={items}
                                  item={item}
                                  paid={!item?.paid}
                                  refresh={refresh}
                                  _id={item?._id}
                                />
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </Fragment>
        ))}
      </tbody>
    </table>
  );
};

export default Treatments;
